import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { useTheme } from 'styled-components';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import LoadingScreen from '../common/LoadingScreen';
import NavBannerMobile from '../common/navigation/common/NavBannerMobile';
import NavigationWrapper from '../common/NavigationWrapper';
import RebrandedNavigationWrapper from '../common/RebrandedNavigationWrapper';
import PrivateRoute from './Private';
import PublicRoute from './Public';
import routes from './routes';
import ScrollToTop from './ScrollToTop';
import useSale from '@/hooks/useSale';

const Head = lazy(() => import('./Head'));

const Routes = () => {
  const [loadLibraries, setLoadLibraries] = useState(false);
  const theme = useTheme();
  const { isSale } = useSale();

  useEffect(() => {
    if (window.isPrerender || window.isLightHouse) {
      setTimeout(() => setLoadLibraries(true), 3000);
    } else {
      setLoadLibraries(true);
    }
  }, []);

  return (
    <Router>
      <>
        <div className="hide-on-desktop">{(isSale ? <NavBannerMobile /> : null)}</div>

        { theme.old
          ? <NavigationWrapper />
          : <RebrandedNavigationWrapper />
        }
        <Suspense fallback={<LoadingScreen />}>
          <ScrollToTop>
            <Switch>
              {routes.map((route, i) => {
                if (route.auth) {
                  return <PrivateRoute key={i} {...route} />;
                } else {
                  return <PublicRoute key={i} {...route} />;
                }
              })}
            </Switch>
          </ScrollToTop>
        </Suspense>
        {loadLibraries && (
          <Suspense fallback={''}>
            <Head />
          </Suspense>
        )}
      </>
    </Router>
  );
};

export default Routes;
